import { RefObject } from 'react';

export const scrollToRef = (ref: RefObject<HTMLDivElement>) => {
  if (ref && ref.current && ref.current.scrollIntoView) {
    ref.current.scrollIntoView();
  }
};
